import React from 'react';
import { css } from '@emotion/core';

import SuccessButton from 'client/game_photoUpload/PhotoUpload/SuccessButton';

export default function ButtonViewMore({
    onClick = () => {},
    style,
    config = {},
    customTextStyle
}) {
    const { buttonText, bgColor, textColor } = config;

    return (
        <SuccessButton
            id="fv-btn-ugc-gallery-view-more"
            text={buttonText}
            onClick={onClick}
            style={[btnStyle(bgColor), style]}
            componentStyle={{
                buttonTextColor: `${textColor}`
            }}
            textStyle={[textStyle, customTextStyle]}
        />
    );
}

const btnStyle = bgColor => css`
    width: auto;
    max-width: unset;
    word-break: break-all;
    margin: auto;
    background: ${bgColor};
    margin: 16px;
    &:hover {
        background-color: ${bgColor};
    }
`;

const textStyle = css`
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    box-sizing: border-box;
`;
